export default __webpack_public_path__ + "static/media/document-background.e9d801d2.png";